import { isLocal } from "@/Environment";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import type { ReactNode } from "react";
import { useState } from "react";
import { useIntercom } from "react-use-intercom";

/**
 * Confirms with the customer, then hands them off to Intercom with a message
 * already written for them.
 *
 * Used for the actions we can't do ourselves yet — cancelling, modifying, and
 * changing the pickup date of an on-hold shipment — so the customer lands in a
 * chat that already says what they want.
 */
export function useViewShipmentsConfirmThenWriteIntercomMessage(
  intercomMessage: string,
  confirmationMessage: string,
): { trigger: () => void; dialogs: ReactNode } {
  const { showNewMessage } = useIntercom();
  const [confirmOpen, setConfirmOpen] = useState(false);

  function onConfirmed() {
    if (isLocal()) {
      console.log(
        "[Intercom] Intercom is not available in local development. In production, Intercom would open with the message:",
        intercomMessage,
      );
    } else {
      showNewMessage(intercomMessage);
    }
  }

  const dialogs = (
    <Dialog
      open={confirmOpen}
      onOpenChange={setConfirmOpen}
      title="Confirm"
      okText="Contact Support"
      onOk={onConfirmed}
    >
      <ControlPresentationProvider presentation="underlined">
        {confirmationMessage}
      </ControlPresentationProvider>
    </Dialog>
  );

  return { trigger: () => setConfirmOpen(true), dialogs };
}
